<template>
    <div class="mt-4">
        <div class="flex flex-col gap-2">
            <div>{{ item.ANOTACE }}</div>
            <div
                v-if="item.PREDPIS"
                class="flex w-fit flex-col *:underline *:underline-offset-2 hover:*:no-underline"
                v-html="item.PREDPIS"
            />
            <TagItemList
                :content="
                    item.METRIKY === '–'
                        ? null
                        : item.METRIKY.replaceAll(';', ',')
                "
                type="metriky"
            />
            <TagItemList
                :content="
                    item.VYKRESY === '–'
                        ? null
                        : item.VYKRESY.split(';')
                              .filter(el => el.includes(type))
                              .join(',')
                "
                label="vrstvy Atlasu"
                type="atlas"
            />
            <TagItemList
                :content="
                    item.DATOVE_VRSTVY === '–' ? null : item.DATOVE_VRSTVY
                "
                type="dat_vrstvy"
            />
            <TagItemList
                :content="
                    item.LIMITY === '–'
                        ? null
                        : item.LIMITY.replaceAll(';', ',')
                "
                type="limity"
            />
            <div
                v-if="temata.length === 1 && temata[0]?.KODSNAZVEM === '–'"
                class="font-promedium"
            >
                {{ temata[0].TEMAINFO }}
            </div>
            <div v-else-if="temata.some(tema => tema.VAZBA === 'Hlavní')">
                <div class="pb-2 font-promedium text-base font-normal">
                    naplnění v tématech:
                </div>
                <div class="grid grid-cols-10 gap-2">
                    <NuxtLink
                        v-for="tema in temata.filter(
                            tema => tema.VAZBA === 'Hlavní'
                        )"
                        :key="tema.KODSNAZVEM"
                        :to="
                            getTemaLink(tema.KODSNAZVEM.split(' ')[0] as string)
                        "
                        :target="type === 'O' ? '_self' : '_blank'"
                        class="contents hover:text-hover-link"
                    >
                        <div
                            class="col-span-3 flex items-center gap-2 place-self-start text-sm"
                        >
                            <img
                                v-if="type === 'O'"
                                class="relative -top-0.5 size-4"
                                :src="`/img/sklicka_250x250/${tema.KODSNAZVEM.split(' ')[0]?.split('.')[0]?.padStart(4, '0')}_250x250.webp`"
                                alt="Logo tématu"
                            />
                            <Icon
                                v-else
                                name="custom:stahovani"
                            />
                            {{ tema.KODSNAZVEM.split(" ")[0] }}
                        </div>
                        <div class="col-span-7 align-middle text-sm">
                            {{
                                tema.KODSNAZVEM.substring(
                                    tema.KODSNAZVEM.indexOf(" ") + 1
                                )
                            }}
                        </div>
                    </NuxtLink>
                </div>
            </div>
            <div v-if="temata.some(tema => tema.VAZBA === 'Souvislost')">
                <div class="pb-2 font-promedium text-base font-normal">
                    souvislost s tématy:
                </div>
                <div class="grid grid-cols-10 gap-2">
                    <NuxtLink
                        v-for="tema in temata.filter(
                            tema => tema.VAZBA === 'Souvislost'
                        )"
                        :key="tema.KODSNAZVEM"
                        :to="
                            getTemaLink(tema.KODSNAZVEM.split(' ')[0] as string)
                        "
                        :target="type === 'O' ? '_self' : '_blank'"
                        class="contents hover:text-hover-link"
                    >
                        <div
                            class="col-span-3 flex items-center gap-2 place-self-start text-sm"
                        >
                            <img
                                v-if="type === 'O'"
                                class="relative -top-0.5 size-4"
                                :src="`/img/sklicka_250x250/${tema.KODSNAZVEM.split(' ')[0]?.split('.')[0]?.padStart(4, '0')}_250x250.webp`"
                                alt="Logo tématu"
                            />
                            <Icon
                                v-else
                                name="custom:stahovani"
                            />
                            {{ tema.KODSNAZVEM.split(" ")[0] }}
                        </div>
                        <div class="col-span-7 align-middle text-sm">
                            {{
                                tema.KODSNAZVEM.substring(
                                    tema.KODSNAZVEM.indexOf(" ") + 1
                                )
                            }}
                        </div>
                    </NuxtLink>
                </div>
            </div>
        </div>
        <div class="flex flex-col gap-2">
            <!-- <div
                v-if="
                    item.TEMAINFO &&
                    item.TEMAINFO.replace(/–, /g, '').length > 1
                "
            >
                {{ item.TEMAINFO.replace(/–, /g, "").split(",")[0] }}
            </div> -->

            <div class="font-proregular text-base">
                odborná garance:
                <span class="font-prolight"
                    >{{ item.KANCELARJEVUTXT }} (<NuxtLink
                        :to="'mailto:' + item.GARANTJEVUEMAIL"
                        class="underline hover:no-underline"
                    >
                        {{ item.GARANTJEVUTXT }} </NuxtLink
                    >)</span
                >
            </div>
            <!-- <div class="font-promedium text-lg">Spolupracovníci</div>
            <table v-if="item.SPOLUPRACEJEV">
                <tbody>
                    <tr
                        v-for="(el, index) in item.SPOLUPRACEJEV.split(',')"
                        :key="index"
                    >
                        <td>{{ el }}</td>
                    </tr>
                </tbody>
            </table> -->
            <div class="font-promedium text-base">poskytovatelé:</div>
            <table
                v-if="item.POSKYTOVATELE"
                class="border-separate-y text-sm"
            >
                <tbody>
                    <tr
                        v-for="(el, index) in item.POSKYTOVATELE.split(';')"
                        :key="index"
                        class="pb-2"
                    >
                        <td>
                            {{ el }}
                            <template
                                v-if="item.POSKYTOVATELE.split(';').length > 1"
                            >
                                <br /><span class="italic">{{
                                    item.ADRESY.split(";")[index]
                                }}</span></template
                            >
                        </td>
                    </tr>
                </tbody>
            </table>
            <NuxtLink
                :to="
                    'mailto:baron@ipr.praha.eu?cc=uap@ipr.praha.eu;lejskova@ipr.praha.eu&subject=Katalog jevů ÚAP – hlášení chyby – ' +
                    item.KOD
                "
                class="w-fit text-sm underline underline-offset-2 hover:no-underline"
                target="_blank"
            >
                Našli jste chybu? <i class="pi pi-arrow-right text-xs" />
            </NuxtLink>
        </div>
    </div>
</template>

<script lang="ts" setup>
const localePath = useLocalePath()
const props = defineProps<{
    item: JevItemProcessed
    type: "O" | "K"
}>()

function getTemaLink(kod: string) {
    if (props.type === "K") {
        return "https://app.iprpraha.cz/apl/mnt/App_UAP/portal/docs/2024/UAPk2024_UAP_textova_cast_web.pdf"
    }
    const knihaKod = kod.split(".")[0]
    const temaKod = kod.split(".").slice(1).join(".")
    return localePath(`/texty/${knihaKod}/${temaKod}`)
}

const temata = computed(() => {
    return props.item.NEW_TEMATA.filter(tema => tema.RELEVANCE === props.type)
})

/* const temy = computed(() => {
    const temas: Tema[] = []
    for (const oblast of props.item.OBLAST) {
        temas.push(...oblast.TEMA)
    }
    return temas.flat()
}) */
</script>

<style></style>
